import React from "react";
import CloseIcon from "@mui/icons-material/Close";
import { closeSnackbar } from "notistack";

const SnackbarConfig = (id) => {
  return <CloseIcon onClick={() => closeSnackbar(id)} />;
};

export default SnackbarConfig;
